import {
  AutomationContext,
  AutomationTrigger,
  IOrder,
} from '@kinet-open-network/shared/data-access/model';

// ─── Producer context interface ────────────────────────────────────────────

export interface IAutomationProducerOrderContext {
  orderId?: string;
}

declare module '@kinet-open-network/shared/data-access/model' {
  /** Adds the pbgas-specific 'order' automation context. */
  interface AutomationContextExtensions {
    pbgas: 'order';
  }

  /** Producer context (minimal IDs) for the order automation context. */
  interface AutomationProducerContextDataMap {
    order: IAutomationProducerOrderContext;
  }

  /** Processor context (loaded entity) for the order automation context. */
  interface AutomationActionContextDataMap {
    order: { order: IOrder<any>; userId?: string };
  }
}

// ─── Registration data (used by app.config) ────────────────────────────

/**
 * Custom automation contexts registration data.
 */
export const pbgasAutomationContextsData: {
  context: AutomationContext;
  label: string;
}[] = [{ context: 'order', label: 'Objednávka' }];

/**
 * Custom automation context triggers registration data.
 */
export const pbgasAutomationContextTriggersData: {
  context: AutomationContext;
  triggers: AutomationTrigger[];
}[] = [
  {
    context: 'order',
    triggers: [AutomationTrigger.Manual, AutomationTrigger.FieldChange],
  },
];
